import { render, staticRenderFns } from "./HelpfulLinksBlock.vue?vue&type=template&id=34418977&"
import script from "./HelpfulLinksBlock.vue?vue&type=script&lang=js&"
export * from "./HelpfulLinksBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports